import { ReactNode } from 'react';
import { Navigate } from 'react-router';

import { useJWTManagerPermissions } from 'domains/jwtToken/hooks/useJWTManagerPermissions';

export interface ProjectsAccessGuardProps {
  children: ReactNode;
  fallback: string;
}

export const ProjectsAccessGuard = ({
  children,
  fallback,
}: ProjectsAccessGuardProps) => {
  const { hasReadAccess, isAllowedJWTsCountLoaded } =
    useJWTManagerPermissions();

  const shouldRedirect = isAllowedJWTsCountLoaded && !hasReadAccess;

  if (shouldRedirect) {
    return <Navigate to={fallback} />;
  }

  return <>{children}</>;
};
